import styled from 'styled-components'
import map from '../static/map.png'

const Container = styled.section`
  padding: ${props => (props.padding ? props.padding : '0px 0px')};
  background: ${props => (props.background ? props.background : '#fff')};
  display: flex;
  flex-direction: ${props => (props.flexDirection ? 'row' : 'column')};
  align-items: ${props => (props.normal ? 'normal' : 'center')};
  margin: ${props => (props.margin ? props.margin : '0px')};
  width: 100%;
  @media (max-width: 992px) {
    padding-left: 20px;
    padding-right: 20px;
  }
  @media (max-width: 768px) {
    padding: 40px 20px;
  }
  @media (max-width: 640px) {
    padding-left: 10px;
    padding-right: 10px;
    flex-direction: column;
  }
`
const ContainerTitle = styled.h1`
  font-size: 38px;
  line-height: 1.21;
  text-align: ${props => (props.align ? props.align : 'center')};
  color: #333333;
  padding-bottom: 10px;

  @media (max-width: 768px) {
    font-size: 28px;
  }
`
const ContainerSubTitle = styled.p`
  font-size: 17px;
  font-weight: 300;
  line-height: 1.53;
  text-align: center;
  color: #999999;
  width: calc(100% - 0%);
  padding-left: 15%;
  padding-right: 15%;
  padding-bottom: ${props => (props.paddingBottom ? props.paddingBottom : '0px')};
  transition: all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms;
  @media (max-width: 768px) {
    font-size: 16px;
    font-weight: 300;
    padding: 0px;
    line-height: 1.63;
  }
  @media (max-width: 520px) {
  padding: 0;
`
const FlexContainer = styled.div`
  display: flex;
  justify-content: space-between;
  @media (max-width: 992px) {
    flex-direction: column;
    width: 100%;
  }
  @media (max-width: 768px) {
    & > div {
      flex-basis: 100%;
      width: 100%;
    }
  }
`
const Font51 = styled.p`
  font-size: 2.25rem;
  line-height: 2.5rem;
  font-weight: 500;
  letter-spacing: -0.025em;
  text-align: ${props => (props.textAlign ? 'left' : 'center')};
  color: #000000;
  max-width: ${props => (props.maxWidth ? props.maxWidth : '640px')};
  @media (max-width: 992px) {
    font-size: 38px;
  }

  @media (max-width: 768px) {
    font-size: 28px;
  }
`
const Font14Tag = styled.span`
  background: #1e40af;
  border-radius: 20px;
  padding: 4px 8px;
  color: #eff6ff;
  @media (max-width: 992px) {
  }

  @media (max-width: 768px) {
  }
`
const Font20 = styled.p`
  font-size: 1rem;
  line-height: 1.5rem;
  letter-spacing: normal;
  text-align: ${props => (props.textAlign ? 'left' : 'center')};
  color: #999999;
  padding-top: 8px;
  padding-bottom: ${props => (props.bottomPadding ? '12px' : 0)};
  @media (max-width: 768px) {
    font-size: 16px;
  }
`
const Font16 = styled.p`
  font-size: 16px;
  font-weight: 300;
  line-height: 1.45;
  letter-spacing: normal;
  text-align: ${props => (props.textAlign ? 'left' : 'center')};
  color: #999999;
  @media (max-width: 768px) {
    font-size: 16px;
  }
`

const Href = styled.a`
  padding: 28px 15px 17px;
  line-height: 1.64;
  letter-spacing: 1.4px;
  position: relative;
  text-transform: uppercase;
  transition: 0.4s linear;
  :hover {
    color: #333333;
  }
`
const ColumnWrapper = styled.div`
  max-width: 600px;
  margin: 0 auto;
  display: flex;
  justify-content: space-around;
`
const CircleImage = styled.div`
  width: ${props => (props.imageSize ? props.imageSize : '100px')};
  height: ${props => (props.imageSize ? props.imageSize : '100px')};
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  // transition: 0.25s linear;
  transition: all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms;

  ${props =>
    props.imageSize !== '270px' &&
    `
  
  &:hover {
    transform: scale(1.05);
  }
  `} & > img {
    height: 100%;
    object-fit: cover;
    width: 100%;
  }
  @media (max-width: 768px) {
    /* width: 40px;
    height: 40px; */
  }
`
const BubbleTop = styled.div`
  justify-content: flex-end;
  ${props =>
    props.tx &&
    props.ty &&
    `

transform: matrix(1, 0, 0, 1,${props.tx}, ${props.ty});

`};
  width: ${props => (props.imageSize ? props.imageSize : '100px')};
  // height: 100%;
  display: flex;
  flex-direction: column;
  z-index: 9;
  align-items: center;
  cursor: pointer;
  transform-origin: 50% 50%;

  transition: all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms;
`
const BubbleWrapper = styled.div`
  opacity: 1;
  transform: matrix(1, 0, 0, 1, 0, 0);
  position: relative;
  transition: all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms;
`
const TeamInfo = styled.div`
  padding-bottom: 40px;
  & > div {
    width: 30px;
    height: 30px;
    background: transparent;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #333;
    font-size: 18px;
    margin: 0 auto;
    border: 1px solid #ddd;
  }
  & > h4 {
    line-height: normal;
    letter-spacing: normal;
    text-align: center;
    color: #333333;
  }
  & > p {
    text-align: center;
    font-size: 18px;
    font-weight: 600;
    line-height: normal;
    letter-spacing: normal;
    color: #333333;
  }
  & > a {
    display: block;
    text-align: center;
    padding-top: 6px;
    & path {
      fill: #0073b1;
    }
  }
  display: ${props => (props.show ? 'block' : 'none')};
  transition: all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms;
`
const BigCircle = styled.div`
  & img {
    width: 100%;
    // filter: grayscale(60%);
  }
  position: relative;
  & > div:first-child {
    justify-content: space-evenly;
  }
  & > div {
    flex-basis: 50%;
  }
  & > div:nth-child(3) {
    min-height: 200px;
    & > div:first-child {
      margin-bottom: auto;
    }
    & > div:nth-child(2) {
      margin: auto;
    }
    & > div:nth-child(5) {
      margin: auto;
    }
    & > div:last-child {
      margin-bottom: auto;
    }
  }
`
const BodyWrapper = styled.div`
  & > footer:first-child {
    @media (max-width: 992px) {
      display: none;
    }
  }
  & > footer:last-child {
    display: none;
    @media (max-width: 992px) {
      display: block;
    }
  }
`
const CollapseWrapper = styled.div`
  visibility: hidden;
  display: flex !important;
  flex-direction: column;
  @media (max-width: 768px) {
    display: block;
    visibility: visible;
  }
  & button {
    align-self: center;
  }
`
const Backgroundwrapper = styled.div`
  background-image: url(${map});
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
  max-width: 100%;
  // height: 500px;
  @media (max-width: 768px) {
    & > div:nth-child(2) {
      display: none;
    }
    display: flex;
    flex-direction: column;
    height: 100%;
    & > button {
      align-self: center;
      position: relative;
      padding: 0;
      padding-right: 14px;
      -webkit-tap-highlight-color: transparent;
      &:after {
        content: '';
        width: 8px;
        height: 8px;
        position: absolute;
        border-left: 2px solid #333333;
        border-bottom: 2px solid #333333;
        transform: ${props => (props.rotate ? 'rotate(135deg)' : 'rotate(-45deg)')};
        margin-left: 6px;
        bottom: ${props => (props.rotate ? 12 : 16)}px;
      }
    }
  }
`
const OurClient = styled.div`
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  max-width: 1366px;
  margin: auto;
  padding: 0 80px;
  @media (max-width: 992px) {
    padding: 0;
  }
  & ul {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    width: 100%;
    padding: 0;
    margin: 0;
    justify-content: center;
    & li {
      width: calc(100% / 5);
      text-align: center;
      list-style-type: none;
      padding: 20px 40px;
      display: flex;
      height: 140px;
      justify-content: center;

      @media (max-width: 992px) {
        width: calc(100% / 3);
      }
      @media (max-width: 520px) {
        width: calc(100% / 2);
      }
      &:hover {
        & img {
          filter: grayscale(0);
        }
      }
      & a {
        display: flex;
      }
      & img {
        width: 120px;
        object-fit: contain;
        position: relative;
        /* filter: grayscale(100%); */
      }
      @media (max-width: 768px) {
        & > img {
          height: 120px;
          object-fit: contain;
        }
      }
    }
  }
`

const SecondSet = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  max-width: 620px;
  min-width: 620px;
  left: -50px;
  margin: 0 auto;
  padding: 100px 0;
  position: relative;
  @media (max-width: 520px) {
    max-width: 240px;
    min-width: 360px;
    padding: 50px 0;
    left: -20px;
  }
`

const CircleCenter = styled.div`
  position: absolute;
  width: 100%;
  top: 0px;
  height: 100%;
  display: flex;
  padding-top: 20px;
  align-items: flex-start;
`
const CircleContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  position: absolute;
  width: 100%;
  & > img {
    height: 20px;
  }
  & > h3 {
    font-size: 21px;

    line-height: 1.52;
    text-align: center;
    color: #333333;
    padding: 44px 0 24px;
    @media (max-width: 520px) {
      padding: 20px 0 10px;
    }
  }
  & > p {
    font-size: 16px;
    line-height: 1.63;
    letter-spacing: 0.1px;
    text-align: center;
    max-width: 400px;
    word-break: break-word;
    @media (max-width: 520px) {
      max-width: 240px;
      font-size: 14px;
    }
  }
`

const Line = styled.div`
  width: 51px;
  height: 1px;
  background-color: rgba(0, 0, 0, 0.1);
  margin-bottom: 26px;
`

const ThirdSet = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  max-width: 490px;
  margin: 0 auto;
  position: relative;
  bottom: 20px;
  @media (max-width: 520px) {
    max-width: 285px;
    min-width: 240px;
    bottom: 1px;
  }
  & div:nth-child(2) {
    position: relative;
    top: ${props => (props.top ? '0px' : '90px')};
    @media (max-width: 520px) {
      top: 55px;
    }
  }
`
export {
  ThirdSet,
  SecondSet,
  Line,
  CircleCenter,
  CircleContent,
  Container,
  ContainerTitle,
  ContainerSubTitle,
  FlexContainer,
  Font51,
  Font20,
  Href,
  ColumnWrapper,
  BubbleTop,
  BubbleWrapper,
  CircleImage,
  TeamInfo,
  BigCircle,
  BodyWrapper,
  CollapseWrapper,
  Backgroundwrapper,
  OurClient,
  Font16,
  Font14Tag
}



// WEBPACK FOOTER //
// ./src/components/StyledComponents.js